import { render, staticRenderFns } from "./GameIntro.vue?vue&type=template&id=2f70d234&"
import script from "./GameIntro.vue?vue&type=script&lang=js&"
export * from "./GameIntro.vue?vue&type=script&lang=js&"
import style0 from "./GameIntro.vue?vue&type=style&index=0&id=2f70d234&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports